/**
 * Created by lu on 2018/4/9.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:nb.model.List,
    method:{
        init:function () {
            var swiperId = 'swiper-id-'+nb.getSeq();
            this.set('swiperId',swiperId);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/swiper/Swiper.js
// module id = 529
// module chunks = 6